import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Tab1Page } from '../../pages/tab1/tab1';
import { Tab2Page } from '../tab2/tab2';
import { FilterPage } from '../../pages/filter/filter';
import { GlobalProvider } from '../../providers/global/global';
import { FormBuilder } from '@angular/forms';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';
import { TimesheetType3Page } from '../timesheet-type3/timesheet-type3';



/**
 * Generated class for the TimesheetlistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-timesheetlist',
  templateUrl: 'timesheetlist.html',
})
export class TimesheetlistPage {


  timeSheetList: Array<string> = [];

  res: any;
  //local: string;
  dataVisability: boolean = false;
  dt: any;
  PeriodFrom: string;
  CompanyName: string;
  TimeTSTotal: string;
  res1: any;
  dt1: any;
  res2: any;
  id: string;
  //dt2: Array<string>;
  gender: string;
  dropdownVisability: boolean = false;
  // status: AbstractControl;
  // formgroup: FormGroup;
  noResult: boolean = false;

  labelVisability: boolean = true;
  //public loading ;
  flag: boolean = false;
  dt_grid1: any;
  dt_grid2: any;
  res_grid1: any;
  res_grid2: any;

  loggedin_fullname : string = "";

  constructor(public global: GlobalProvider, public http: HttpClient, public navCtrl: NavController,
    public navParams: NavParams, public formbuilder: FormBuilder, public popoverCtrl: PopoverController) {
    this.loggedin_fullname = localStorage.getItem("Fullname");

    this.global.ColourBanner1 = localStorage.getItem('ColourBanner1') ? localStorage.getItem('ColourBanner1') : this.global.ColourBanner1;
    this.global.ColourBanner2 = localStorage.getItem('ColourBanner2') ? localStorage.getItem('ColourBanner2') : this.global.ColourBanner2;
    this.global.ColourDeSelected = localStorage.getItem('ColourDeSelected') ? localStorage.getItem('ColourDeSelected') : this.global.ColourDeSelected;
    this.global.ColourFont = localStorage.getItem('ColourFont') ? localStorage.getItem('ColourFont') : this.global.ColourFont;
    this.global.ColourFont1 = localStorage.getItem('ColourFont1') ? localStorage.getItem('ColourFont1') : this.global.ColourFont1;
    this.global.ColourFont2 = localStorage.getItem('ColourFont2') ? localStorage.getItem('ColourFont2') : this.global.ColourFont2;
    this.global.ColourHighlight = localStorage.getItem('ColourHighlight') ? localStorage.getItem('ColourHighlight') : this.global.ColourHighlight;
    this.global.contacttype = localStorage.getItem('ContactType') ? localStorage.getItem('ContactType') : this.global.contacttype;
    this.global.fullname = localStorage.getItem('Fullname') ? localStorage.getItem('Fullname') : this.global.fullname;
    this.global.logo = localStorage.getItem('logo') ? localStorage.getItem('logo') : this.global.logo;
    this.global.contactid = localStorage.getItem('ContactId') ? localStorage.getItem('ContactId') : this.global.contactid;
    this.global.agencyid = localStorage.getItem('agencyid') ? localStorage.getItem('agencyid') : this.global.agencyid;
    this.global.status = localStorage.getItem('Status') ? localStorage.getItem('Status') : this.global.status;
    this.global.AllowApproval = localStorage.getItem('AllowApproval') ? localStorage.getItem('AllowApproval') : this.global.AllowApproval;
    //debugger
    //this.global.AllowApproval = '1';
    this.httpRequest();

    this.global.TAB2id = new Array;
    this.global.TAB2Caption = new Array;

  }

  // doRefresh(refresher) {
  //   console.log('Begin async operation', refresher);

  //   setTimeout(() => {
  //     console.log('Async operation has ended');
  //     refresher.complete();
  //   }, 2000);
  // }

  httpRequest() {

    this.global.createLoader();
    this.global.loading.present().then((result) => {

      var p: any = {};
      p.status = this.global.status;
      p.period = this.global.period;
     
      const params = new HttpParams().set('j', JSON.stringify(p))

      this.http.post('timesheets/timesheet_list/', params).subscribe(

        (data) => {


          this.global.loading.dismiss();

          this.res = data;

          if (this.res.result == false) {
            this.dataVisability = false;
            this.noResult = true;

          }
          else {
            this.dataVisability = true;
            this.noResult = false;
            this.dt = JSON.parse(this.res.dt);

            /////////client////////
            // for(var i=0;i<this.dt.length; i++){
            //   //debugger;
            //   console.log('dtrate'+this.dt[i]['Rating']);
            //   this.global.rate[i] = this.dt[i]['Rating'];
            //   console.log('rate'+this.global.rate[i]);
            // }
            //console.log('get data:   ' + this.dt);
          }

        },
        error => { alert('error'); }
      );
    }).catch((err) => {

    });
  }

  httpRequestGrid_Footer(timesheettype: string, timesheetid: string) {
    this.global.createLoader();
    this.global.loading.present().then((result) => {

      var p: any = {};
      p.timesheetid = this.global.timesheetid;
      p.timesheettype = this.global.timesheettype;
      p.contacttype = this.global.contacttype;
      p.entity = 'TOTALS2FOOTER';


      const params = new HttpParams()
        .set('j', JSON.stringify(p))


      this.http.post('timesheets/timesheet_read/', params).subscribe(

        (data) => {
          // debugger
          var res: any = data;

          if (res.result == true) {
            var dt_footer = JSON.parse(res.dt);
            var f = JSON.parse(dt_footer[0])[0];
            var autofill = f.AutoFillEnabled;

            this.global.footersettings = f ? f :  {};

            this.global.timesheetinstructions0 = f.TimesheetInstructions0 ? f.TimesheetInstructions0 : "";
            this.global.timesheetinstructions1 = f.TimesheetInstructions1 ? f.TimesheetInstructions1 : "";

            this.global.timesheetinstructions0mobile = f.TimesheetInstructions0Mobile ? f.TimesheetInstructions0Mobile : "";
            this.global.timesheetinstructions1mobile = f.TimesheetInstructions1Mobile ? f.TimesheetInstructions1Mobile : "";

            if (autofill == 0) {
              this.global.autofillEnabled = false;
            } else if (autofill == 1) {
              this.global.autofillEnabled = true;
            }
            this.global.button1caption = f.Button1Caption;
            this.global.button2caption = f.Button2Caption;
            this.global.button2validator = f.Button2Validator;

            this.global.showRejectButton = f.ShowRejectButton;
            this.httpRequestGrid_Header(timesheettype, timesheetid);
          } else {
            this.global.autofillEnabled = false;
            this.httpRequestGrid_Header(timesheettype, timesheetid);
          }


        },
        error => {
          alert('error');
        }
      );

    }).catch((err) => {

    });
  }

  httpRequestGrid_Header(timesheettype: string, timesheetid: string) {

    var p: any = {};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.entity = 'HEADER';


    const params = new HttpParams()
      .set('j', JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/', params).subscribe(

      (data: any) => {

        if (data.result == true) {
          var dt_header = JSON.parse(data.dt);

          var h = JSON.parse(dt_header[0])[0];

          // console.log('hello', h);

          this.global.grid1ValueReadOnly = h.Grid1ValuesReadOnly;
          this.global.grid2ValueReadOnly = h.Grid2ValuesReadOnly;
          this.global.grid3ValueReadOnly = h.Grid3ValuesReadOnly;
          this.global.FlipGrids = h.FlipGrids;
          this.global.TimesheetPeriod = h.TimesheetPeriod;
          this.global.TimeInputControl = h.TimeInputControl;


          this.httpRequestTab1(timesheettype, timesheetid);

        } else {

          this.httpRequestTab1(timesheettype, timesheetid);

        }


      },
      error => {
        alert('error');
      }
    );

  }

  httpRequestTab1(timesheettype: string, timesheetid: string) {

    var p: any = {};
    p.timesheetid = timesheetid;
    p.timesheettype = timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = '';
    p.entity = 'TAB1';

    const params = new HttpParams()
      .set('j', JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/', params).subscribe(
      (data) => {


        this.res1 = data;

        if (this.res1.result == true) {

          this.dt1 = JSON.parse(this.res1.dt);
          var caption = [];
          for (var i = 0; i < this.dt1.length; i++) {
            caption[i] = this.dt1[i]['Caption'];
            this.global.id = this.dt1[i]['ID'];
          }

          this.global.loading.dismiss();
          this.goToTab1(caption);


        }
        else {
          //redirect to tab2

          //this.goToTab2(this.contactId, this.contacttype,timesheetid ,timesheettype,this.agencyId, this.id);

          this.global.id = '0';
          this.httpRequestTab2();
        }
      },
      error => { alert('error'); }
    );


  }


  httpRequestTab2() {

    var p: any = {};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = this.global.id;
    p.entity = 'TAB2';

    const params = new HttpParams()
      .set('j', JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/', params).subscribe(
      (data) => {
        //this.flag = false;

        this.res2 = data;
        if (this.res2.result == true) {
          //debugger;
          var dt2 = JSON.parse(this.res2.dt);
          this.global.dt2 = JSON.parse(dt2[0]);
          //console.log('len: ' + this.global.dt2.length);

          this.global.TAB2Caption = [];
          this.global.TAB2id = [];
          this.global.TAB2TotalTime = [];
          for (var i = 0; i < this.global.dt2.length; i++) {
            // debugger
            this.global.TAB2Caption[i] = this.global.dt2[i]['Caption'];
            this.global.TAB2id[i] = this.global.dt2[i]['ID'];
            this.global.TAB2TotalTime[i] = this.global.dt2[i]['TotalTime'];
            //this.global.dt2 = JSON.parse(this.res2.dt);
          }


          if (this.global.dt2.length < 2) {

            this.httpRequestGrid1_read();
          }
          else {
            this.global.loading.dismiss();
            this.goToTab2();
          }


        }
        else {
          this.global.loading.dismiss();
          //this.httpRequestGrid1_read();
        }


      },
      error => { alert('error'); }
    );

  }

  httpRequestGrid1_read() {

    var p: any = {};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = this.global.TAB2id[0];
    p.entity = 'GRID1';

    const params = new HttpParams()
      .set('j', JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/', params).subscribe(

      (data) => {



        this.res_grid1 = data;
        if (this.res_grid1.result == true) {

          //debugger;
          this.global.dt_grid1 = JSON.parse(this.res_grid1.dt);
          this.global.grid1Visibility = true;
          this.httpRequestGrid2_read();

        }
        else {
          this.global.grid1Visibility = false;
          this.httpRequestGrid2_read();
        }
      },
      error => {
        alert('error');
      }
    );

  }

  httpRequestGrid2_read() {

    var p: any = {};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = this.global.TAB2id[0];
    p.entity = 'GRID2';

    const params = new HttpParams()
      .set('j', JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/', params).subscribe(

      (data) => {

        this.global.loading.dismiss();

        // debugger;
        this.res_grid2 = data;
        if (this.res_grid2.result == true) {
          //console.log('2: ' + this.res2);
          //debugger;
          this.global.dt_grid2 = JSON.parse(this.res_grid2.dt);
          this.global.dt2table1 = JSON.parse(this.global.dt_grid2[0]);
          this.global.grid2Visibility = true;

          this.global.setGrid2Option();

          this.navCtrl.push(TimesheetType3Page, { TAB2ID: this.global.TAB2id[0] });

        }
        else {
          this.global.grid2Visibility = false;
          this.navCtrl.push(TimesheetType3Page, { TAB2ID: this.global.TAB2id[0] });
        }


      },
      error => {
        alert('error');
      }
    );
  }

  /////////client////////
  // httpRequest_rating_save(){


  //   var p:any={};

  //   p.contacttype = this.global.contacttype;
  //   p.timesheetid = this.global.timesheetid;

  //   p.rating = this.global.rate[this.global.timesheetIndex];

  //   const params = new HttpParams()
  //   .set('j',JSON.stringify(p))


  //   this.http.post('timesheets/timesheet_rating_save/',params).subscribe(

  //     (data) => {

  //       console.log('Rating saved');

  //     },
  //     error => {alert('error');}
  //   );
  // }

  goToTab1(caption: Array<string>) {


    this.navCtrl.push(Tab1Page, { caption: caption, id: this.id });

  }


  goToTab2() {


    this.navCtrl.push(Tab2Page);
  }

  rowClick(i: number) {

    /////////client////////
    //this.global.timesheetIndex = i;
    this.global.timesheettype = this.dt[i]['TimesheetType'] == '4' ? '1' : this.dt[i]['TimesheetType'];
    this.global.timesheetid = this.dt[i]['TimeSheetId'];
    this.httpRequestGrid_Footer(this.global.timesheettype, this.global.timesheetid);
    // this.httpRequestTab1(this.global.timesheettype,this.global.timesheetid);

    //console.log("okkkkkkkkkkkkk");
  }



  filterclick() {
    this.navCtrl.push(FilterPage, {});

  }


  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({
      ev: myEvent
    });
  }

  /////////client////////
  // onRateChange(i:number){

  //   console.log(this.global.rate[i]);
  //   this.global.timesheetIndex = i;

  //   this.global.timesheetid =this.dt[i]['TimeSheetId'];
  //   this.httpRequest_rating_save();
  // }


  ionViewDidLoad() {
    console.log('ionViewDidLoad TimesheetlistPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/timesheetlist/timesheetlist.ts